import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

class Checkout extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Objects.Checkout
					id={this.props.account}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					shouldSave={this.state["saveModelUser"]}
					shouldReloadCart={this.props.shouldReloadCart}
					scannedCode={this.props.scannedCode}
					baseUrl={this.props.baseUrl}
					auto_cc_fee={!!this.props.auto_cc_fee}
					apply_cc_fee_to_debit={this.props.apply_cc_fee_to_debit == null ? true : !!this.props.apply_cc_fee_to_debit}
					posLocation={this.props.posLocation}
				/>
			</div>
		)
	}
};

export default Framework.Components.withRootState(Checkout);
